import { Badge } from "@/components/ui/badge";
import { getLang, t } from "@/i18n";

export const money = (n, cur = "USD") => (n === null || n === undefined ? "—" : new Intl.NumberFormat(getLang() === "es" ? "es-MX" : "en-US", { style: "currency", currency: cur }).format(n));
export const L = (obj) => (obj ? obj[getLang()] || obj.es : "");

const TAX = {
  missing: { label: "Pendiente de enviar", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  submitted: { label: "En revisión", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  approved: { label: "Aprobado", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  rejected: { label: "Rechazado", cls: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
};
export const TaxBadge = ({ status = "missing", testId }) => <Badge variant="outline" className={TAX[status]?.cls} data-testid={testId}>{t(TAX[status]?.label || status)}</Badge>;

const PAY = { pending: { label: "Por pagar", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" }, paid: { label: "Pagado", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" } };
export const PayBadge = ({ status, testId }) => <Badge variant="outline" className={PAY[status]?.cls} data-testid={testId}>{t(PAY[status]?.label || status)}</Badge>;

export const RateBadge = ({ rate, treaty, testId }) => (
  <span className={`inline-flex items-center gap-1 text-xs font-medium ${rate === 0 ? "text-emerald-400" : rate < 30 ? "text-sky-300" : "text-amber-300"}`} data-testid={testId}>
    {rate}% {treaty ? t("(tratado)") : t("(sin tratado)")}
  </span>
);
